/**
 * @module views\sys\page
 */
import Vue from "vue";
import Component from "vue-class-component";
import GhBase from "@/components/ghBase";
import GhTablePage from "@/components/ghTablePage/ghTablePage";
import { Watch } from "vue-property-decorator";
import GhMenu from "../../components/ghMenu/ghMenu";

@Component
export default class Page extends GhBase {
  private argsQuery = { keyword: "", type: "", menu_cd: "" };

  private menuName = "";

  private codeSelectedTable = "前台代码";

  private tableConfig: ITableState | null = null;

  private typeProp: IProp = {
    value: "Type",
    type: "string",
    text: "页面类型"
  };

  private getPropType(props: IProp[], name: string) {
    if (props && name) {
      return props.find(item => item.value === name);
    }
    return {};
  }

  private updateTableConfig(value) {
    this.tableConfig = value;
    if (this.tableConfig) {
      this.typeProp = this.getPropType(
        this.tableConfig.props as IProp[],
        "Type"
      ) as IProp;
    }
  }

  private selectedMenu(node) {
    if (node) {
      this.argsQuery.menu_cd = node.data.Cd;
      this.menuName = node.data.Name;
      let menu = this.$refs.menu as GhMenu;
      menu.close();
      let table = this.$refs.table as GhTablePage;
      if (table) {
        table.query();
      }
    }
  }

  private menuClear() {
    this.argsQuery.menu_cd = "";
    this.menuName = "";
    let table = this.$refs.table as GhTablePage;
    if (table) {
      table.query();
    }
  }

  private submitCode(model) {
    let refs = ["codeService", "codePage"];
    refs.map(item => this.codeEditSubmit(item));
  }

  private codeEditSubmit(ref) {
    let editor = this.$refs[ref] as IndexObject;
    if (editor) {
      editor.submit();
    }
  }
}
